









































































import GetCatImage from "@/components/GetCatImage.vue";
import CatCard from "@/components/CatCard.vue";
import Vue from "vue";
import { Cat } from "@/common/types";

export default Vue.extend({
  metaInfo() {
    return {
      title: "Random",
      titleTemplate: "%s - Catcyclopedia",
      htmlAttrs: {
        lang: "en"
      },
      meta: [
        {
          vmid: "description",
          name: "description",
          content: `Are you considering getting a new friend? Cat information database with images and descriptions.`
        }
      ]
    };
  },

  components: {
    "get-cat-image": GetCatImage,
    "cat-card": CatCard
  },

  data() {
    return {
      name: "",
      description: ""
    };
  },

  computed: {
    cat(): Cat {
      return this.$store.state.cats.find((cat: Cat): boolean => {
        return cat.id === this.breedId;
      });
    },

    indoor(): string {
      return this.cat.indoor === 0 ? "Yes" : "No";
    },

    pet(): string {
      return this.cat.lap === 0 ? "No" : "Yes";
    },

    smartCats(): Array<Cat> {
      return this.$store.state.cats
        .filter(
          (cat: Cat): boolean =>
            cat.intelligence === this.cat.intelligence &&
            this.cat.name != cat.name
        )
        .slice(0, 3);
    },

    lovingCats(): Array<Cat> {
      return this.$store.state.cats
        .filter(
          (cat: Cat): boolean =>
            cat.affection_level === this.cat.affection_level &&
            this.cat.name != cat.name
        )
        .slice(0, 3);
    }
  },

  props: ["breedId"]
});
